<template>
  <div id="app">
    <header>
      <HeaderV />
    </header>
    <main>
      <FormulairePaiement />
    </main>
    <footer>
      <FooterV />
    </footer>
  </div>
</template>
  
  <script lang="ts">
import { defineComponent, onMounted } from "vue";
import HeaderV from "@/components/Landing/HeaderV.vue";
import FormulairePaiement from "@/components/Landing/FormulairePaiement.vue";
import FooterV from "@/components/Landing/FooterV.vue";
import { retraitChargement } from "@/utils/utils";

export default defineComponent({
  name: "ProcessPaiement",
  components: {
    HeaderV,
    FormulairePaiement,
    FooterV,
  },
  setup: () => {
    onMounted(() => {
      retraitChargement();
    });
    return {};
  },
});
</script>
  
<style scoped>

</style>
  